import React from 'react';
import { Modal, Box, withStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import PropTypes from 'prop-types';

@withStyles(theme => {
  return {
    container: {
      height: '100%',
      width: '100%'
    },
    close_icon: {
      color: 'white',
      position: 'absolute',
      top: '-32px',
      right: '-32px',
      fontSize: '32px',
      cursor: 'pointer',
      zIndex: 1,
      '@media screen and (max-height: 630px)': {
        top: '-6px'
      },
      [theme.breakpoints.down('xs')]: {
        top: 6,
        right: 6,
        color: theme.palette.common.black
      }
    }
  }
})
class CustomModal extends React.Component {
  render () {
    const {
      classes,
      children,
      open,
      onClose,
      contentClassName,
      hideCloseIcon
    } = this.props;
    return (
      <Modal
        open={open}
        disableScrollLock
        disableRestoreFocus>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          className={classes.container}
          onClick={event => {
            if (event.currentTarget.isSameNode(event.target)) {
              onClose();
            }
          }}>
          <Box
            textAlign="center"
            display="inline-block"
            position="relative"
            className={contentClassName}>
            {!hideCloseIcon && (
              <Close
                onClick={onClose}
                className={classes.close_icon}
              />
            )}
            {children}
          </Box>
        </Box>
      </Modal>
    );
  }
}

CustomModal.propTypes = {
  open: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  onClose: PropTypes.func.isRequired,
  disableScrollLock: PropTypes.bool,
  contentClassName: PropTypes.string
}

export default CustomModal